<template>
    <div>
        <div
            v-if="loading"
            class="form-spinner"
        >
            <span class="fa fa-spinner fa-lg fa-pulse" />
        </div>

        <div class="form-group">
            <div>
                <div class="row">
                    <div class="col col-md-6">
                        <select
                            v-model="tab"
                            class="form-control"
                            @change="emitChange"
                        >
                            <option value="any">
                                Любой из
                            </option>
                            <option value="all">
                                Все из
                            </option>
                        </select>
                    </div>
                    <div class="col col-md-6">
                        <v-select 
                            v-model="products"
                            placeholder="Выберите товары"
                            multiple
                            :options="productsList"
                            @input="emitChange"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group mb-0">
            <div class="row">
                <div class="col col-md-6">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">C: </span>
                        </div>
                        <date-picker
                            ref="start"
                            v-model="start_"
                            :config="startconfig"
                            @dp-change="updateDate($event, 'start')"
                        />
                    </div>
                </div>
                <div class="col col-md-6">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">По: </span>
                        </div>
                        <date-picker
                            ref="end"
                            v-model="end_"
                            :config="endconfig"
                            @dp-change="updateDate($event, 'end')"
                        />
                    </div>
                </div>
                </div>
            </div>
        </div>
</template>

<script>
    import ClauseMixin from './ClauseMixin.vue';

    export default {
        name: 'ProductField',
        mixins: [ClauseMixin],
        props: {
            cache: {
                type: Array,
                default: function() { return [] },
            }
        },
        data: function() {
            return { 
                tab: ['any', 'all'].includes(this.content.clause) ? this.content.clause : 'any',
                loading: true,
                products: this.content.products || [],
                productsList: [] 
            }
        },
        mounted: function() {
            this.emitChange();
            if (this.cache) {
                this.productsList = this.cache;
                this.loading = false;
            } else {
                let cmp = this;
                $.ajax({
                    type: "POST",
                    url: '/analytics/'+cmp.siteid+'/products/',
                    success: function ( data ) {
                        if (data.products) {
                            cmp.productsList = data.products;
                            cmp.$emit('fetched', data.products);
                        }
                        cmp.loading = false;
                    },
                    error: function(error) {
                        alert('Не удалось получить список товаров');
                        cmp.loading = false;
                    }
                });
            }
        },
        methods: {
            setTab: function(tab) {
                this.tab = tab;
                this.emitChange();
            },
            emitChange: function() {
                let range = this.validateDate();

                if (range.start && range.end) {
                    this.$emit('change', {
                        'id': this.id,
                        'type': 'madeOrderWithProducts',
                        'products': this.products,
                        'clause': this.tab,
                        'start': range.start.toISOString(),
                        'end': range.end.toISOString(),
                    });
                }
            },
        },
    }
</script>

